import get from 'lodash/get';
import {interval,Observable,of} from 'rxjs';
import {
  filter,
  map,
  mergeMap,
  takeUntil,
  throttleTime
} from 'rxjs/operators';

import * as reducer from '../reducers/inactivity';
import * as auth from '../reducers/auth';
import config from '../../config/config';

const trackActivity = stop$ => () => {
  const activity$ = new Observable(obs => {
    window.addEventListener('mousemove', e => obs.next(e));
    window.addEventListener('scroll', e => obs.next(e));
    window.addEventListener('keydown', e => obs.next(e));
    return () => {
      window.removeEventListener('mousemove', () => false);
      window.removeEventListener('scroll', () => false);
      window.removeEventListener('keydown', () => false);
    };
  });
  const obs$ = activity$.pipe(
    throttleTime(10000), // take only one event per 10 seconds
    takeUntil(stop$)
  );
  return obs$;
};

const isInactive = (
  state$,
  _reducer,
  _auth,
  maxTime = 15 * 60 * 1000 // 15 minutes
) => () => {
  const priorState = get(state$, 'value.inactivity');
  const now = Date.now();
  const startTime = priorState.lastActivityTimestamp;
  const millisecondsElapsed = now - startTime;
  const isInactive = millisecondsElapsed >= maxTime;
  return isInactive;
};

export const trackActivityEpic = (
  action$,
  state$,
  _reducer = reducer
) => action$.pipe(
  filter(a => a.type === _reducer.start.type),
  mergeMap(trackActivity(
    action$.pipe(filter(a => a.type === _reducer.stop.type))
  )),
  map(() => _reducer.newActivity())
);

export const checkInactivityEpic = (
  action$,
  state$,
  intervalTime = 15000, // every 15 seconds
  _reducer = reducer,
  _auth = auth
) => action$.pipe(
  filter(a => a.type === _reducer.start.type),
  // every N seconds, check if the user needs to be logged out but only until
  // the stop action is called
  mergeMap(() => interval(intervalTime).pipe(
    takeUntil(
      action$.pipe(filter(a => a.type === _reducer.stop.type))
    )
  )),
  map(isInactive(state$, _reducer, _auth)),
  mergeMap(expired =>
    expired && !config().inactivityLogoutDisabled
    ? of(_auth.logout())
    : of()
  )
);

export const startOnLoginEpic = (
  action$,
  state$,
  _reducer = reducer,
  _auth = auth
) => action$.pipe(
  filter(a => a.type === _auth.setCredentials.type),
  map(() => _reducer.start())
);

export const stopOnLogoutEpic = (
  action$,
  state$,
  _reducer = reducer,
  _auth = auth
) => action$.pipe(
  filter(a => a.type === _auth.logout.type),
  map(() => _reducer.stop())
);
